import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { ClixelDirective } from '@rma/generic/ui/trixels';
import { SmsUrlPipe } from '@rma/generic/util/pipes/sms-url';
import { ProfileContactAnalytics } from '@rma/profiles/public/domain';
import { AgentPhoneLinkComponent } from '@rma/profiles/public/util-phone-link';

@Component({
  selector: 'rma-result-contact',
  imports: [AgentPhoneLinkComponent, ClixelDirective, MatButtonModule, MatDialogModule, RmaIconComponent, SmsUrlPipe, TranslocoModule],
  templateUrl: './contact.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultContactComponent {
  @Input()
  profileCode!: string;

  @Input()
  name!: string;

  @Input()
  phone: string | undefined;

  @Input()
  isMobile: boolean | undefined = false;

  @Input()
  email!: string;

  @Input()
  trixelUrl!: string;

  @Input()
  contactAnalytics!: ProfileContactAnalytics;

  @Input()
  showMarketReport = false;

  @Output()
  contact = new EventEmitter<void>();
}
